import { ExclamationTriangleIcon } from '@heroicons/react/20/solid'

export default function WarningAlert({ title = "", warning }) {
  return (
    <div className="mb-4 rounded-md bg-yellow-50 p-4 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/15">
      <div className="flex">
        <div className="shrink-0">
          <ExclamationTriangleIcon aria-hidden="true" className="size-5 text-yellow-400" />
        </div>
        <div className="ml-3">
          <h3 className={`text-sm font-medium text-yellow-800 dark:text-yellow-100`}>
            {title}
          </h3>
          <div className={`text-sm text-yellow-700 dark:text-yellow-100/80 ${title ? "mt-2" : ""}`}>
          {Array.isArray(warning) ? (
            <ul role="list" className="list-disc space-y-1 pl-5">
              {warning.map((err, idx) => (
                <li className="ml-4" key={idx}>{err}</li>
              ))}
            </ul>) :
            (<p>{warning}</p>)
          }
          </div>
        </div>
      </div>
    </div>
  )
}
